import { render } from "./PublicOrderView.vue?vue&type=template&id=6845a319&scoped=true"
import script from "./PublicOrderView.vue?vue&type=script&lang=js"
export * from "./PublicOrderView.vue?vue&type=script&lang=js"

import "./PublicOrderView.vue?vue&type=style&index=0&id=6845a319&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6845a319"]])

export default __exports__